import { render, staticRenderFns } from "./HistoryBlock.vue?vue&type=template&id=9a9df340&"
import script from "./HistoryBlock.vue?vue&type=script&lang=js&"
export * from "./HistoryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports